/**
 * Läuft an diesem Gerät gerade eine Station? Ein Prüfling ist gewählt und noch nicht
 * abgegeben. Nur dann gibt `TIME_ADD` Zeit (Entscheidung des Nutzers, 2026-10-07): nach der
 * Abgabe ist es zu spät, vor dem ersten Prüfling gibt es nichts zu verlängern.
 *
 * Nimmt nur die drei Felder des App-Zustands, die es braucht — `domain/` kennt den Store nicht.
 */
export function stationLaeuft(s: {
  startup: { kind: string };
  candidateId: string;
  submitted: Record<string, unknown>;
}): boolean {
  return s.startup.kind === 'bereit' && s.candidateId !== '' && !s.submitted[s.candidateId];
}
